// src/schemas/registerValidation.js
import * as Yup from 'yup';

export const registrationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('First Name is required')
    .max(50, 'First Name cannot exceed 50 characters'),

  lastName: Yup.string()
    .required('Last Name is required')
    .max(50, 'Last Name cannot exceed 50 characters'),

  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),

  phoneNumber: Yup.string()
    .required('Phone Number is required')
    .matches(/^[0-9]{10,15}$/, 'Phone number must be 10-15 digits'),

  location: Yup.string()
    .required('Location is required')
    .max(100, 'Location cannot exceed 100 characters'),

  password: Yup.string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters')
    .max(20, 'Password cannot exceed 20 characters'),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Confirm Password is required'),
});
